let state = {
    Main: { 
        Desc:
        {
            desc:"Добиться бескомпромиссного звучания – это основная цель компании Monitor Audio. Не важно, смотрите ли вы кино или слушаете музыку, инновационные технологии акустических систем Silver позволят вам насладиться реалистичным звучанием, переносящим слушателя в самую гущу событий. ",
            title_1: 'Максимализм Silver',
            text_1: [['Богатая история британского Hi-Fi позволяет Monitor Audio использовать этот багаж для создания совершенных образцов стиля, технической безупречности и качества изготовления. Каждая из девяти моделей линейки Silver 6G стала результатом самого трепетного отношения наших конструкторов и мастеров, которые так же увлечены музыкой, как и вы. И нынешнее семейство стильных колонок, демонстрирующих великолепное фирменное звучание, явилось результатом более чем сорокалетнего опыта разработки акустики. Стереосистема и домашний кинотеатр никогда ещё не звучали так здорово!']],
            title_2: "Созданы для вас",
            text_2: [["Чтобы минимизировать искажения, обеспечивая чистейшие средние частоты и идеально совмещая звучание разных каналов, мы использовали технологии, разработанные для моделей флагманской серии Platinum II. Специализируясь в изготовлении металлических диффузоров, инженеры компании Monitor Audio разработали для этой линейки совершенно новые динамики. Изготовленные вручную корпуса отделаны натуральным шпоном премиального качества, белым или чёрным лаком."],
                    ["Какую бы модель Silver нового поколения вы не выбрали для аудио-видео системы, вы откроете для себя заново свою музыкальную и кинотеатральную коллекцию – как будто слышите их впервые!"]
            ]
        }
    },
    Sections : [
         [
        {
            href: "https://www.pult.ru/product/polochnaya-akustika-monitor-audio-silver-50-high-gloss-black",
            h1: "Полочные колонки",
            className:"right",
            title: "Silver 50",
            text: `Можете быть уверены: эти компактные полочники способны обеспечить большой динамичный звук. В существенной мере – благодаря революционному СЧ/НЧ-динамику со 133 мм диффузором из C-CAM. Солидный опыт конструкторов и продвинутые технологии – очень мощные магниты, работающие на большую (32 мм) звуковую катушку – обеспечивают впечатляющую мощность (100 Вт) и плотный ударный бас. Магнитное насыщение было ликвидировано, что позволило получить меньше искажений и гораздо более чистое звучание в целом. Малыши Silver 50 прекрасно работают, будучи установленными недалеко от стены, несмотря на заднее расположение порта фазоинвертора. Особую прочность компактному корпусу придаёт использование специальных распорок и крепление динамика одним болтом через заднюю стенку колонки. `,
            priceOld: "64 990 ₽",
            priceNew: "47 118 ₽",
            src: "/img/pic1.png",
            alt: "Silver 50"
        },
        {
            href: "https://www.pult.ru/product/polochnaya-akustika-monitor-audio-silver-100-black-oak",
            className:"left",
            title: "Silver 100",
            text: `Массивный и мощный 203 мм СЧ/НЧ-динамик C-CAM идеально вписан
            в конструкцию корпуса Silver 100 и способен перемещать большие
            объёмы воздуха, создавая невероятно динамичную звуковую картину
            и хороший бас. Звучание этих колонок отличается выдающимся
            разрешением – не важно, озвучивают ли они большой симфонический
            оркестр или громкий рок-концерт. Всё это дается им удивительно
            легко – практически, как хорошим напольникам. За счёт высокой мощности (120 Вт) и динамичности, Silver 100 станет прекрасным выбором для просторных помещений – как для стерео, так и для домашнего кинотеатра.
            `,
            priceOld: "79 990 ₽",
            priceNew: "57 993 ₽",
            src: "/img/pic2.png",
            alt: "Silver 100"
        }
    ],
     [
        {
            href: "https://www.pult.ru/product/napolnaya-akustika-monitor-audio-silver-200-satin-white",
            h1: "напольные колонки",
            className:"right",
            title: "Silver 200",
            text: `Эти изящные напольные колонки были специально разработаны
            для размещения в полной гармонии с современным интерьером.
            Конструкция позволяет не только эффектно вписаться в ограниченное
            пространство, но и поразить серьёзным звучанием. Пара динамиков
            со 133 мм C-CAM-диффузорами позволяют Silver 200 замечательно
            воспроизводить и басы, и СЧ/НЧ-диапазон. Они работают в отдельных
            акустических камерах, создавая отличную стереокартину независимо
            от того, находитесь ли вы на оси оптимального воспроизведения.
            Массивные магниты динамиков обеспечивают удивительно низкий
            бас для колонок таких габаритов, которые при необходимости можно
            ставить близко к стене. Высокая мощность 150 Вт. Пусть вас не обманывают скромные размеры
            Silver 200: это серьёзная акустика для Hi-Fi и домашнего кинотеатра
            с недюжинными способностями.`,
            priceOld: "124 990 ₽",
            priceNew: "90 618 ₽",
            src: "/img/pic3.png",
            alt: "Silver 200"
        },
        {
            href: "https://www.pult.ru/product/napolnaya-akustika-monitor-audio-silver-300-black-oak",
            className:"left",
            title: "Silver 300",
            text: `Полноценная трёхполосная конструкция объединяет напор и великолепную передачу среднечастотного диапазона с помощью 100 мм динамика. Фирменная «увеличенная» звуковая катушка и специальная магнитная система обеспечивают этому динамику предельно низкий уровень искажений а также высокую мощность 200 Вт. Пара длинноходных 152 мм НЧ-динамиков работают в унисон, создавая мощную поддержку.
            Оптимально настроив работу каждого из динамиков в конкретном небольшом диапазоне, удалось добиться выдающегося звучания. С учётом более высокого сопротивления и отличного демпфирования системы, колонки можно ставить всего в 30 см от стены – и даже в этом случае вам гарантирован быстрый контролируемый мощный бас. Эту акустику легко раскачать за счёт высокой чувствительности, что делает Silver 300 хорошим выбором для прослушивания динамичной музыки в средних и больших помещениях, и к ней легко подобрать усилитель. `,
            priceOld: "159 990 ₽",
            priceNew: "115 993 ₽",
            src: "/img/pic4.png",
            alt: "Silver 300"
        },
        {
            href: "https://www.pult.ru/product/napolnaya-akustika-monitor-audio-silver-500-black-oak",
            className:"right",
            title: "Silver 500",
            text: `Невероятные Silver 500 – квинтэссенция бескомпромиссного
            звучания. Пара мощных длинноходных 203 мм C-CAM-динамиков
            низкочастотного диапазона создают могучий чёткий бас, нижней
            границей которого стали внушительные 30 Гц и высокую мощность 250 Вт. Для системы, где фронтальными колонками выбраны Silver 500, даже при прослушивании самой специфической музыки сабвуфер становится необязательным.
            Отдельный СЧ-динамик обеспечивает чистейшее звучание без
            единого намёка на искажения, воспроизводя вокальные партии так
            естественно, что вы заслушаетесь!`,
            priceOld: "189 990 ₽",
            priceNew: "137 743 ₽",
            src: "/img/pic5.png",
            alt: "Silver 500"
        }
    ],
     [
        {
            href: "https://www.pult.ru/product/akustika-centralnogo-kanala-monitor-audio-silver-c150-black-oak",
            h1: "АКУСТИКА ЦЕНТРАЛЬНОГО КАНАЛА",
            className:"right",
            title: "Silver C150",
            text: `На центральный канал в системе домашнего кинотеатра приходится до 60% звукового материала. Компактный Silver C150, но мощный (150 Вт), настроен так, чтобы совпадать по тембру со звучанием моделей Silver 50 и Silver 200, обеспечивая цельную картину во фронтальной плоскости домашнего
            кинотеатра. Корпус C150 достаточно компактен, чтобы поместиться на полку AV-стойки, необходимость в специальной подставке отпадает. Эта колонка отлично работает при установке вплотную к стене и в нишах, обеспечивая превосходное стабильное звучание.`,
            priceOld: "48 990 ₽",
            priceNew: "35 518 ₽",
            src: "/img/pic6.png",
            alt: "Silver C150"
        },
        {
            href: "https://www.pult.ru/product/akustika-centralnogo-kanala-monitor-audio-silver-c350-walnut",
            className:"left",
            title: "Silver C350",
            text: `Эта модель создана для серьёзных систем домашнего кинотеатра, когда необходимо бескомпромиссное качество звучания. Мощность 200 Вт. За счёт вертикальной ориентации динамиков, колонка даёт такую же диаграмму направленности, как и другие модели Silver, обеспечивая идеальную
            интеграцию в рамках системы, и станет идеальным партнёром для моделей Silver 100, Silver 300 или Silver 500. Разработчики точно подобрали их характеристики и тембральность звучания. Если вам нужен эффективный центр с максимально чистым звучанием, то лучше Silver C350 вы не найдёте. Послушайте – и вы удивитесь!`,
            priceOld: "74 990 ₽",
            priceNew: "54 368 ₽",
            src: "/img/pic7.png",
            alt: "Silver C350"
        }
    ],
     [
        {
            href: "https://www.pult.ru/product/nastennaya-akustika-monitor-audio-silver-6g-fx-black-oak",
            h1: `Колонки пространственного
            звучания и сабвуфер`,
            className:"right",
            title: "Silver FX",
            text: `Назначение этой модели – служить в качестве тыловых и боковых каналов. Трёхгранная передняя панель оснащена 152 мм СЧ/НЧ-динамиком C-CAM с технологией RST, обеспечивающей
            улучшенную жёсткость и минимальный уровень искажений. Мощность 85 Вт. Пара «золотых» купольных твитеров с вентилируемой неодимовой магнитной системой чётко воспроизводят высокие частоты. Колонки
            можно повесить на стену, а с помощью переключателя легко настроить звучание: сделать его направленным, или наоборот – рассеянным. Идеальное решение для домашнего кинотеатра премиум-класса. 
            `,
            priceOld: "64 990 ₽",
            priceNew: "47 118 ₽",
            src: "/img/pic8.png",
            alt: "Silver FX"
        },
        {
            href: "https://www.pult.ru/product/sabvufer-monitor-audio-silver-w-12-walnut",
            className:"left",
            title: "Silver W-12",
            text: `Компактный мощный сабвуфер оснащён
            500-ваттным усилителем с DSP, дающим максимальный контроль динамики и масштаба. Закрытый корпус позволяет получить плотный и быстрый бас вплоть до 22 Гц в обычной комнате. Инновационная технология Monitor Audio позволяет
            автоматически подстраивать звучание под особенности помещения. Система определяет проблемные частоты (резонансы и пр.) и корректирует выходную амплитудно-частотную характеристику, имея целью добиться максимально чистого воспроизведения низких частот. `,
            priceOld: "119 990 ₽",
            priceNew: "86 993 ₽",
            src: "/img/pic9.png",
            alt: "Silver W-12"
        }
    ]

    ],
    FooterList : [
        [
            {   id: "1item",
                idCol: "1Col",
                title: "PULT.RU",
                href: "https://www.pult.ru/main/akustika",
                text: "О компании"
            },
            {
                href: "https://www.pult.ru/contacts/",
                text: "Контакты"
            },
            {
                href: "https://www.pult.ru/contacts/",
                text: "Салоны"
            },
            {
                href: "https://www.pult.ru/news/",
                text: "Новости"
            },
            {
                href: "https://www.pult.ru/articles/",
                text: "Обзоры и статьи"
            }

        ],
        [
            {   id: "2item",
                idCol: "2Col",
                title: "Каталог",
                href: "https://www.pult.ru/main/akustika",
                text: "Акустика"
            },
            {
                href: "https://www.pult.ru/main/hi-fi/",
                text: "Hi-Fi"
            },
            {
                href: "https://www.pult.ru/main/vinil/",
                text: "Винил"
            },
            {
                href: "https://www.pult.ru/main/naushniki/",
                text: "Наушники"
            },
            {
                href: "https://www.pult.ru/main/televizory/",
                text: "Телевизоры"
            },
            {
                href: "https://www.pult.ru/main/proektory/",
                text: "Проекторы"
            }

        ],
        [
            {   id: "3item",
                idCol: "3Col",
                title: "Выгоды",
                href: "https://www.pult.ru/sale/rasprodaja/",
                text: "Распродажа"
            },
            {
                href: "https://www.pult.ru/sale/rasprodaja/",
                text: "Outlet"
            },
            {
                href: "https://www.pult.ru/action/",
                text: "Акции"
            },
            {
                href: "https://www.pult.ru/skidki-i-bonusi/",
                text: "Бонусы и скидки"
            },
            {
                href: "https://www.pult.ru/oplata/pokupka-v-rassrochku",
                text: "Рассрочка"
            }

        ]
    ]
    
}
export default state;